(window as any).global = window;

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

import { initAll } from 'govuk-frontend';
initAll();

// Enable mobile debugging console in development mode
if (!environment.production) {
  import('eruda').then(eruda => eruda.default.init());
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
